<template>
  <div class="mainChild page-content" id="lowPriceDetails">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>违规检索数据统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="headerBrand">
      <section class="seaerch-wrapper">
        <div class="title f16" style="font-size: 20px;font-weight: 600;margin: 16px 0 16px 0;">
          <span
            v-for="(item,i) in newPlateList"
            :key="i"
            :class="activeKey == item.dictCode?'active':''"
            @click="navChange(item)"
          >{{item.dictName}}</span>
        </div>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="商品标题" :label-width="formLabelWidth">
            <el-input clearable placeholder="请输入商品标题" v-model="list.itemtitle" size="small"></el-input>
          </el-form-item>
          <el-form-item label="产品信息" :label-width="formLabelWidth">
            <el-cascader
              filterable
              clearable
              size="small"
              v-model="productid"
              :options="options2"
              :props="productidChildren"
              collapse-tags
              @change="handleChange"
              @visible-change="getListBybmcid2"
              style="width: 100%;"
              :disabled="cascaderDisabled"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-select v-model="list.shopname" multiple filterable placeholder="请选择店铺" size="small">
              <el-option
                v-for="item in shopData"
                :key="item.id"
                :label="item.shopName"
                :value="item.shopName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="复查状态" :label-width="formLabelWidth">
            <el-select v-model="list.reviewresult" placeholder="请选择" size="small">
              <el-option label="全部" value=""></el-option>
              <el-option label="待复查" value="1"></el-option>
              <el-option label="已复查-合格" value="2"></el-option>
              <el-option label="已复查-不合格" value="3"></el-option>
              <el-option label="超时未复查" value="4"></el-option>
              <el-option label="特殊链接" value="5"></el-option>
              <el-option label="未设置" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input clearable placeholder="请输入备注" v-model="list.remark" size="small"></el-input>
          </el-form-item>
          <el-form-item label="日期范围" :label-width="formLabelWidth">
            <el-date-picker
              clearable
              v-model="searchformDate"
              type="daterange"
              start-placeholder="请选择"
              end-placeholder="请选择"
              range-separator="~"
              :picker-options="pickerOptions"
              size="small"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="店铺性质" :label-width="formLabelWidth" style="margin-top: 4px;">
            <el-select v-model="shoptype" placeholder="请选择" size="small" clearable>
              <el-option label="灰名单" value="灰名单"></el-option>
              <el-option label="黑名单" value="黑名单"></el-option>
              <el-option label="授权店铺" value="授权店铺"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品ID" :label-width="formLabelWidth">
            <el-input clearable placeholder="请输入" v-model="itemid" size="small"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 4px;">
            <el-button size="small" class="search-btn" @click="getIprViolationRetrieveDataList(1)">查  询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <el-dialog :title="downTitle"
      class="importModal"
      :visible.sync="BulkImportShow"
      :close-on-click-modal="false"
      width="640px"
      id="dialog">
      <div class="wrap" style="margin: 10px;">
        <el-upload
          ref="newupload"
          class="upload-demo"
          drag
          :action="actionUrl"
          :auto-upload="false"
          multiple
          :before-upload="beforeUpload"
          accept=".xls,.xlsx"
          :on-success="confirmUpload"
          >
          <i class="el-icon-upload" style="color: #BDA571;"></i>
          <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
            <br>
            <span style="font-size: 14px;color: #d4d4d4;">
              支持扩展名：.xls .xlsx
            </span>
          </div>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
        <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <div class="downContainer" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <div class="downBtn" v-if="logintype==='KEFU'">
        <el-button size="small" type="primary"  @click="onOpenDeleteDia(7)" :disabled="disbutton">下载数据</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(4)" :loading="autoreviewShow" v-if="list.platform != 'PDD'">自动复查</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(1)">设置整改形式</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(3)">设置特殊链接</el-button>
        <el-button size="small" :disabled="disbutton" @click="customSpeech">自定义话术</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(5)">违规处理</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(6)">设置复查状态</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(2)">批量删除</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(8)">批量导入</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(9)">生成截图</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(10)">推送消息</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(11)" v-if="bmcKefuid == '4394'">检索数据导入</el-button>

        <el-tag effect="dark" style="margin-left: 10px;" v-if="!disbutton && newShow">
          全平台有{{autoreviewNum}}条违规链接复查未完成。
        </el-tag>
      </div>
      <div class="downBtn" v-else>
        <el-button size="small" type="primary"  @click="onOpenDeleteDia(7)" :disabled="disbutton">下载数据</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(2)">批量删除</el-button>
        <el-button size="small" :disabled="disbutton" @click="onOpenDeleteDia(8)">批量导入</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{total}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <!--表格-->
      <el-table ref="multipleTable" :data="tableList" style="width: 100%" @selection-change="handleSelectionChange" @row-click="onOpenDrawer">
        <el-table-column type="selection" width="30" fixed="left">
        </el-table-column>
        <el-table-column label="序号" align="left" width="70">
          <template slot-scope="scope">
            <div style="float: left;">
              {{scope.$index+1}}
            </div>
            <div style="float: right;width: 25px;height: 25px;" v-if="scope.row.specialstatus">
              <el-image :src='require("@/assets/img/errLink.png")'></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" prop="itemtitle" width="480">
          <template slot-scope="scope" class="shopInfo">
            <div class="shopMain">
              <img :src="scope.row.logopicurl" alt/>
              <div class="content">
                <el-link v-if="scope.row.platform == 'WPH' && scope.row.itemtype == 2" class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink.split('&skuid')[0]" type="primary" target="_blank">
                  {{scope.row.itemtitle}}
                </el-link>
                <el-link v-else class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
                  {{scope.row.itemtitle}}
                </el-link>
                <div class="align_left">
                  {{scope.row.productname}}
                  <el-popover placement="top-start" width="200" trigger="hover" v-if="scope.row.productprice">
                    <div>
                      <div v-for="item in  $options.filters.objToAr(JSON.parse(scope.row.productprice))" :key="item.name">
                        <div>{{item.name}}:{{item.val}}</div>
                      </div>
                    </div>
                    <i class="el-icon-warning-outline" slot="reference"></i>
                  </el-popover>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="价格" width="220">
          <template slot-scope="scope">
            <div style="float: left;width: 100%;">
              <div v-if="scope.row.price" style="float: left;">标价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                 {{scope.row.price}}</div>
              <div v-if="scope.row.islowprice == 'true'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              <div v-if="scope.row.checkprice" style="float: left;">标价限价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                 {{scope.row.checkprice}}</div>
            </div>
            <div style="float: left;;width: 100%;">
              <div v-if="scope.row.availableprice" style="float: left;">
                到手价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                 {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.availableislowprice == 'true'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
              <div v-if="scope.row.availablecheckprice" style="float: left;">
                到手限价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                 {{scope.row.availablecheckprice}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="复查状态"  width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click.stop="skuListChildShow(1,scope.row.itemid,scope.row.syncdate,scope.row.platformcode)" v-show="scope.row.itemtype == 2" style="margin-top: 5px">
              SKU列表
            </el-button>
            <div v-show="scope.row.itemtype != 2">
              {{scope.row.reviewresult}}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="优惠说明" width="320">
          <template slot-scope="scope" v-if="scope.row.coupons">
            <couponsZzj :zzjCoupons="scope.row.coupons.split(',')"/>
          </template>
        </el-table-column>
        <el-table-column label="店铺信息"  width="320" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
            <div v-else class="align_left ellipsis">/</div>
            <div v-show="scope.row.wangwang" class="align_left ellipsis">{{scope.row.wangwang}}</div>
            <div class="tall_icon">
              <img
                :src="require('@/assets/img/platform/pla_'+scope.row.platform+'.png')"
                alt
                class="edit_icon"
              />
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="grey" v-show="scope.row.shoptype=='灰名单'">灰</span>
              <span class="black" v-show="scope.row.shoptype=='黑名单'">黑</span>
              <span class="green" v-show="scope.row.shoptype== '授权店铺'">授权</span>
            </div>
            <!-- <div class="align_left ellipsis">{{scope.row.dealername}}</div> -->
          </template>
        </el-table-column>
        <el-table-column label="状态" width="250">
          <template slot-scope="scope">
            <div v-show="scope.row.status=='上架'" class="have">上架</div>
            <div v-show="scope.row.status=='下架'" class="out">下架</div>
            <div v-show="scope.row.status=='已删除'" class="out">已删除</div>
            <div v-show="scope.row.status=='链接失效'" class="failure">链接失效</div>
            <div v-show="scope.row.ischange == '是'" slot="reference" style="cursor:pointer" class="haveImg" @click="changeClick(scope.row.itemid,scope.row.platform)">
              <img src="https://brm.olonger.com/ex-img/zhiwen-status.png"/>
            </div>
            <div v-show="scope.row.camisreport" class="haveImg">
              <img src="https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572505655208.png"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="colItem in tableAdd"
          v-if="colItem.showtype != 2 && colItem.fieldname !== '低价截图'"
  		    :prop="colItem.fieldvalue"
          :label="colItem.fieldname"
          width="200"
        >
        </el-table-column>
        <el-table-column label="低价截图" width="200px">
          <template slot-scope="scope">
            <img :src="scope.row.screenshot_url" style="width: 45px;height: 94px;" alt/>
          </template>
        </el-table-column>
        <el-table-column label="数据更新时间" width="200px"  fixed="right" class-name="lastTime">
          <template slot="header" slot-scope="scope">
            数据更新时间
            <i class="el-icon-setting" style="color: #409EFF;margin-left: 74px;cursor: pointer;" @click="setTableTitle"></i>
          </template>
          <template slot-scope="scope">
            <span v-show="scope.row.synchrotime">{{scope.row.synchrotime}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage"
        :pageSizes="[10, 20, 50, 100]"
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>

    <!-- sku信息 -->
    <el-dialog :visible.sync="skuShow" width="70%" title="SKU列表" id="elDialog">
      <el-table :data="skuData" style="width: 100%" v-loading="skuloading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @row-click="onOpenDrawer">
        <el-table-column label="序号" align="left" type="index" width="50">
          <template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
        </el-table-column>
        <el-table-column prop="skuname" label="SKU名称">
          <template slot-scope="scope">
            <div class="skuname">{{scope.row.skuname}}</div>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="220">
          <template slot-scope="scope">
            <div style="float: left;width: 100%;">
              <div v-if="scope.row.price" style="float: left;">标价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                {{scope.row.price}}</div>
              <div v-if="scope.row.islowprice == 'true'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              <div v-if="scope.row.checkprice" style="float: left;">标价限价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                {{scope.row.checkprice}}</div>
            </div>
            <div style="float: left;;width: 100%;">
              <div v-if="scope.row.availableprice" style="float: left;">
                到手价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.availableislowprice == 'true'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
              <div v-if="scope.row.availablecheckprice" style="float: left;">
                到手限价：
                <span v-if="list.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="list.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="list.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="list.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="list.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="list.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                  ¥
                </span>
                {{scope.row.availablecheckprice}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="reviewresult" label="复查状态">
        </el-table-column>
        <el-table-column prop="name" label="产品">
          <template slot-scope="scope">
            <div class="productname">
              <span v-if="scope.row.productname">{{scope.row.productname}}</span>
              <el-popover placement="top-start" width="200" trigger="hover" v-show="scope.row.productprice">
                <div>
                  <div v-for="item in  $options.filters.objToAr(JSON.parse(scope.row.productprice))" :key="item.name">
                    <div>{{item.name}}:{{item.val}}</div>
                  </div>
                </div>
                <i class="el-icon-warning-outline" slot="reference"></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-if="skuData&&skuData.length>0"
        :currentPage.sync="currentPage2"
        :pageSizes="[10, 20, 50, 100]"
        :total="total2"
        @handleSizeChange="handleSizeChange2"
        @handleCurrentChange="handleCurrentChange2"
      ></pagination>
    </el-dialog>
    <!-- 设置表头弹框 -->
    <setTableTitle :modalInfo="setModalInfo"  @reqTableData="reqTableData"  ref="setModal" :numType="5"/>
    <!-- 删除 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="360px" style="margin-top: 10%;" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">
            你确认要删除<span>{{delType}}</span>信息吗？
          </div>
          <div style="font-size: 14px;">删除后
            <span style="color: #e90e24;font-size: 14px;">
              信息将会被彻底删除
            </span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteReview" size="small" :loading="ficationLoading">确 定</el-button>
        <el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-drawer custom-class="el-drawer-deal el-drawer-credit" :visible.sync="detilShow" size="840px">
      <div slot="title" class="detail-header">
        <div style="font-size: 16px;float: left;width: 100%;">
          <span style="float: left;">
            {{datilData.shopname}}
          </span>
          <ShopType :shoptype="datilData.shoptype" style="float: left;margin-top: 4px;"/>
        </div>
        <div>
          <Shopname :platform="datilData.platform" />
          <span v-if="datilData.rectificationform == 0" style="margin-left: 200px;">
            通知改价
          </span>
          <span v-if="datilData.rectificationform == 1" style="margin-left: 200px;">
            通知下架
          </span>
          <span style="margin-left: 200px;">
            {{datilData.reviewresult}}
            <span v-if="datilData.reviewresult == '待复查'">
              {{datilData.reviewtime}}
            </span>
          </span>
        </div>
      </div>
      <div class="con-info violationInfo">
    		<panelTitle title="违规信息"/>
    		<el-card class="con-item-main">
    			<div class="item">
    				<span class="title">通知ID：</span>
    				<p class="con">{{datilData.noticeid}}</p>
    			</div>
    			<div class="item">
    				<span class="title">平台：</span>
    				<p class="con">{{datilData.platform | platformChinese}}</p>
    			</div>
    			<div class="item">
    				<span class="title">店铺名称：</span>
    				<p class="con">{{datilData.shopname}}</p>
    			</div>
    				<div class="item" v-if="datilData.platform == 'TBTM' || datilData.platform == 'TM' || datilData.platform == 'TB'">
    				<span class="title">旺旺：</span>
    				<p class="con">{{datilData.wangwang}}</p>
    			</div>
    			<div class="item">
    				<span class="title">商品链接：</span>
    				<div class="con">
              <el-link type="primary" :href="datilData.itemlink.split('&skuid=')[0]" :underline="false" target="_blank" v-if="datilData.platform == 'WPH'">
                {{datilData.itemlink.split('&skuid=')[0]}}
              </el-link>
              <el-link type="primary" :href="datilData.itemlink" :underline="false" target="_blank" v-else>
                {{datilData.itemlink}}
              </el-link>
            </div>
    			</div>
    			<div class="item">
    				<span class="title">产品信息：</span>
    				<p class="con">{{datilData.productname}}</p>
    			</div>
    			<div class="item">
    				<span class="title">商品名称：</span>
    				<p class="con">{{datilData.itemtitle}}</p>
    			</div>
    			<div class="item">
    				<span class="title">SKU信息：</span>
    				<p class="con">{{datilData.skuname}}</p>
    			</div>
    			<div class="item item-flex">
    				<div class="item-left">
    					<span class="title">标价：</span>
    					<p class="con" v-if="datilData.price">
                <span v-if="datilData.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="datilData.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="datilData.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="datilData.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="datilData.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="datilData.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="datilData.platform != 'LZDMY' && datilData.platform != 'LZDTH' && datilData.platform != 'LZDPH' && datilData.platform != 'LZDID' && datilData.platform != 'LZDSG' && datilData.platform != 'LZDVN'">
                  ¥
                </span>
                {{`${datilData.price}`}}
              </p>
    				</div>
    				<div class="item-right">
    					<span class="title">标价限价：</span>
    					<p class="con" v-if="datilData.checkprice">
                <span v-if="datilData.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="datilData.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="datilData.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="datilData.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="datilData.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="datilData.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="datilData.platform != 'LZDMY' && datilData.platform != 'LZDTH' && datilData.platform != 'LZDPH' && datilData.platform != 'LZDID' && datilData.platform != 'LZDSG' && datilData.platform != 'LZDVN'">
                  ¥
                </span>
                {{`${datilData.checkprice}`}}
              </p>
    				</div>
    			</div>
    			<div class="item item-flex">
    				<div class="item-left">
    					<span class="title">到手价：</span>
    					<p class="con" v-if="datilData.availableprice">
                <span v-if="datilData.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="datilData.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="datilData.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="datilData.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="datilData.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="datilData.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="datilData.platform != 'LZDMY' && datilData.platform != 'LZDTH' && datilData.platform != 'LZDPH' && datilData.platform != 'LZDID' && datilData.platform != 'LZDSG' && datilData.platform != 'LZDVN'">
                  ¥
                </span>
                {{`${datilData.availableprice}`}}
              </p>
    				</div>
    				<div class="item-right">
    					<span class="title">到手价限价：</span>
    					<p class="con" v-if="datilData.availablecheckprice">
                <span v-if="datilData.platform == 'LZDVN'">
                  ₫
                </span>
                <span v-if="datilData.platform == 'LZDSG'">
                  $
                </span>
                <span v-if="datilData.platform == 'LZDID'">
                  Rp
                </span>
                <span v-if="datilData.platform == 'LZDPH'">
                  ₱
                </span>
                <span v-if="datilData.platform == 'LZDTH'">
                  ฿
                </span>
                <span v-if="datilData.platform == 'LZDMY'">
                  RM
                </span>
                <span v-if="datilData.platform != 'LZDMY' && datilData.platform != 'LZDTH' && datilData.platform != 'LZDPH' && datilData.platform != 'LZDID' && datilData.platform != 'LZDSG' && datilData.platform != 'LZDVN'">
                  ¥
                </span>
                {{`${datilData.availablecheckprice || 0}`}}
              </p>
    				</div>
    			</div>
    			<div class="item">
    				<span class="title">参考销量：</span>
    				<p class="con">{{datilData.salevolume}}</p>
    			</div>
    			<div class="item">
    				<span class="title">通知时间：</span>
    				<p class="con" v-if="datilData.createtime">{{datilData.createtime | fullTime}}</p>
    			</div>
          <div class="item">
    				<span class="title">低价截图：</span>
    				<p class="con" v-if="datilData.screenshot_url">
              <img :src="datilData.screenshot_url" style="width: 135px;height: 282px;" alt/>
            </p>
    			</div>
    		</el-card>
        <div class="con-info" v-if="datilData.reviewresult !== '超时未复查'">
          <!-- 待复查 || 编辑-->
          <div
            class="awaitreview"
            v-if="isEdit"
          >
            <panelTitle title="复查情况" />
            <el-card>
              <el-form
                :model="reviewForm"
                :rules="rules"
                ref="reviewForm"
                label-width="100px"
                size="mini"
              >
                <el-form-item label="复查结果：" prop="reviewresult">
                  <el-radio-group v-model="reviewForm.reviewresult" size="mini" class="border_none_radio">
                    <el-radio label="合格" border>合格</el-radio>
                    <el-radio label="不合格" border>不合格</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="复查截图：" style="margin-top: 22px;">
                  <uploadPic
                    v-if="datilData.reviewurl && datilData.reviewurl.indexOf(',') != -1"
                    ref="uploadPic"
                    @getpic="getpic"
                    :imgList="datilData.reviewurl.split(',') || []"
                  ></uploadPic>
                  <uploadPic
                    v-else
                    ref="uploadPic"
                    @getpic="getpic"
                    :imgList="datilData.reviewurl || []"
                  ></uploadPic>
                  <div class="intro">支持上传9张截图，图片格式PNG、JPG，单张图片大小20M以内。</div>
                </el-form-item>
                <el-form-item label="复查说明：">
                  <el-input
                    type="textarea"
                    placeholder="请输入备注说明，请保持在200字以内"
                    maxlength="200"
                    v-model="reviewForm.reviewstate"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-card>
            <div class="btn-wrap">
              <el-button type="primary" size="mini" @click="reviewConfirm()">确认</el-button>
              <el-button size="mini" @click="isEdit = false">取消</el-button>
            </div>
          </div>
          <!-- 已复查 -->
          <div
            class="reviewed"
            v-if="!isEdit"
          >
            <panelTitle title="复查情况" />
            <span class="update-time" @click="editClick(datilData.rectificationform,datilData.reviewresult)" style="color: #108cee;cursor: pointer;" v-if="datilData.reviewresult != '未设置'">
              <i class="el-icon-edit"></i> 编辑
            </span>
            <el-card class="con-info">
              <div class="item">
                <span class="title">复查标价：</span>
                <p class="con" v-if="datilData.reviewbidprice">
                  <span v-if="list.platform == 'LZDVN'">
                    ₫
                  </span>
                  <span v-if="list.platform == 'LZDSG'">
                    $
                  </span>
                  <span v-if="list.platform == 'LZDID'">
                    Rp
                  </span>
                  <span v-if="list.platform == 'LZDPH'">
                    ₱
                  </span>
                  <span v-if="list.platform == 'LZDTH'">
                    ฿
                  </span>
                  <span v-if="list.platform == 'LZDMY'">
                    RM
                  </span>
                  <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                    ¥
                  </span>
                  {{datilData.reviewbidprice}}
                </p>
              </div>
              <div class="item">
                <span class="title">复查到手价：</span>
                <p class="con" v-if="datilData.reviewtheirprice">
                  <span v-if="list.platform == 'LZDVN'">
                    ₫
                  </span>
                  <span v-if="list.platform == 'LZDSG'">
                    $
                  </span>
                  <span v-if="list.platform == 'LZDID'">
                    Rp
                  </span>
                  <span v-if="list.platform == 'LZDPH'">
                    ₱
                  </span>
                  <span v-if="list.platform == 'LZDTH'">
                    ฿
                  </span>
                  <span v-if="list.platform == 'LZDMY'">
                    RM
                  </span>
                  <span v-if="list.platform != 'LZDMY' && list.platform != 'LZDTH' && list.platform != 'LZDPH' && list.platform != 'LZDID' && list.platform != 'LZDSG' && list.platform != 'LZDVN'">
                    ¥
                  </span>
                  {{datilData.reviewtheirprice}}
                </p>
              </div>
              <div class="item">
                <span class="title">优惠信息：</span>
                <p class="con">{{datilData.couponsstate}}</p>
              </div>
              <div class="item">
                <span class="title">复查结果：</span>
                <span class="con">{{datilData.reviewresult}}</span>
              </div>
              <div class="item">
                <span class="title">复查截图：</span>
                <div class="con img-wrap" v-if="datilData.reviewurl && datilData.reviewurl.indexOf(',') != -1">
                    <img
                      v-for="(item,index) in datilData.reviewurl.split(',')"
                      :src="item"
                      alt
                      :key="index"
                    />
                </div>
                <div class="con img-wrap" v-else>
                    <img :src="datilData.reviewurl" alt v-if="datilData.reviewurl"/>
                </div>
              </div>
              <div class="item">
                <span class="title">复查说明：</span>
                <p class="con">{{datilData.reviewstate}}</p>
              </div>
              <div class="item">
                <span class="title">复查人：</span>
                <p class="con">{{datilData.reviewkefu}}</p>
              </div>
              <!-- <div class="item" v-if="!isOuter">
                <span class="title">复查时间：</span>
                <p class="con">{{datilData.updatetime | fullTime}}</p>
              </div> -->
            </el-card>
          </div>
        </div>
    	</div>
    </el-drawer>
    <!-- 自定义话术 -->
    <el-dialog title="自定义话术" :visible.sync="customShow" width="360px" style="margin-top: 10%;" id="dialog">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="设置话术" :label-width="formLabelWidth">
          <el-input clearable placeholder="请输入话术" v-model="speechcraft" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="insertSpeechcraft" size="small" :loading="insertLoading">确 定</el-button>
        <el-button @click="customShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 下载数据 -->
    <el-dialog title="下载数据" :visible.sync="downDataShow" width="430px" style="margin-top: 10%;" id="dialog">
      <el-radio v-model="radioType" label="1">{{delIds ? '数据下载' : '全部数据下载'}}</el-radio>
      <el-radio v-model="radioType" label="2" v-if="list.platform == 'TBTM' || list.platform == 'JD' || list.platform == 'PDD' || list.platform == 'DD'">通知数据下载</el-radio>
      <el-radio v-model="radioType" label="3">复查数据下载</el-radio>
      <el-radio v-model="radioType" label="4">导入数据下载</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="downTable" :loading="lowPriceLoading">确 定</el-button>
        <el-button @click="downDataShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 整改形式 -->
    <el-dialog title="设置整改形式" :visible.sync="recFormShow" width="430px" style="margin-top: 10%;" id="dialog">
      <el-radio v-model="rectificationform" label="0">通知改价</el-radio>
      <el-radio v-model="rectificationform" label="1">通知下架</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="recForm" :loading="recFormLoading">确 定</el-button>
        <el-button @click="recFormShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 复查状态 -->
    <el-dialog title="设置复查状态" :visible.sync="reviewstateShow" width="430px" style="margin-top: 10%;" id="dialog">
      <el-radio v-model="reviewstateChange" label="合格">合格</el-radio>
      <el-radio v-model="reviewstateChange" label="不合格">不合格</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="updatereviewAll" :loading="reviewstateLoading">确 定</el-button>
        <el-button @click="reviewstateShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 自动复查 -->
    <el-dialog title="自动复查" :visible.sync="automaticShow"  width="680px" id="setTags" style="margin-top: 10%;">
      <el-form class="search-form" v-loading="automaticLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-form-item label="复查状态：" label-width="110px">
          <el-select v-model="reviewresult" placeholder="请选择" size="small" style="width: 300px;" clearable>
            <el-option label="待复查" value="1"></el-option>
            <el-option label="已复查-合格" value="2"></el-option>
            <el-option label="已复查-不合格" value="3"></el-option>
            <el-option label="超时未复查" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-checkbox-group v-model="checkboxGroup" size="mini" style="margin-left: 23px;">
          <el-checkbox-button v-for="item in newPlateList" :label="item.dictName" :key="item.dictCode" v-if="item.dictCode != 'PDD'" :disabled="item.disabledshow">{{item.dictName}}</el-checkbox-button>
        </el-checkbox-group>
        <el-form-item label-width="20px">
          <div style="text-align: right;">
            <el-button type="text" >
              <i class="el-icon-check" style="font-size: 18px;" @click="autoreview"></i>
            </el-button>
            <el-button type="text">
              <i class="el-icon-close" style="font-size: 18px;"></i>
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label-width="30px">
          <div style="font-weight: bold;">
            复查情况预估
          </div>
          <div>
            当前 {{autoreNum}} 条数据,复查时间预计 {{autoreTime}} 秒。
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="autoreNum != 0">
        <el-button type="primary" @click="uodatepystatus" size="small" :loading="uodateLoading">确 定</el-button>
        <el-button @click="automaticShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 设置特殊链接 -->
    <el-dialog title="设置特殊链接" :visible.sync="linkShow"  width="480px" id="setTags" style="margin-top: 10%;">
      <el-radio v-model="linkType" label="0">自定义限价标准</el-radio>
      <el-radio v-model="linkType" label="1">特殊链接</el-radio>
      <el-form class="search-form" style="margin-top: 30px;" v-if="linkType == '0'">
        <el-form-item label="自定义标价" label-width="110px">
          <el-input clearable placeholder="请输入" v-model="checkprice" size="small" type="number"></el-input>
        </el-form-item>
        <el-form-item label="自定义到手价" label-width="110px">
          <el-input clearable placeholder="请输入" v-model="availablecheckprice" size="small" type="number"></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex;width: 100%;justify-content:center;margin-top: 30px;" v-else>
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div style="font-size: 16px;line-height: 35px;margin-left: 10px;">
          选择的特殊链接不进行自动复查，属于特殊类型的链接。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCheckPrice" size="small" :loading="linkLoading">确 定</el-button>
        <el-button @click="linkShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 违规处理 -->
    <el-dialog title="违规处理" :visible.sync="illegalShow"  width="480px" id="setTags" style="margin-top: 10%;">
      <div style="display: flex;width: 100%;justify-content:center;margin-top: 30px;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div style="font-size: 16px;line-height: 35px;margin-left: 10px;">
          你确认要批量转移违规信息么？转移后<span style="color: red;">相同的链接只展示一条</span>。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="insertReportBatchByIprLowPrice" size="small" :loading="illegalLoading">确 定</el-button>
        <el-button @click="illegalShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 消息推送 -->
    <el-dialog title="消息推送" :visible.sync="pushMessageShow" width="360px" style="margin-top: 10%;height: 346px;" :close-on-click-modal="false">
      <div style="display: flex;width: 100%;justify-content:center;line-height: 35px;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;margin-right: 10px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要推送违规数据吗？</div>
          <div style="font-size: 14px;">点击后
            <span style="color: #e90e24;font-size: 14px;">
              低价信息将会被推送
            </span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wechatData()" size="small">确 定</el-button>
        <el-button @click="pushMessageShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from "components/dataTable/pagination";
import aes from "@/libs/aes";
import setTableTitle from "components/setTableTitle";  //设置表头
import { renderShopName ,renderProductInfo} from "@/libs/renderCommon";
import { fetchGet } from "@/libs/reqCommon";
import Shopname from "@/components/shopname/Shopname.vue";
import ShopType from "@/components/shopType";
import couponsZzj from "@/components/couponsZzj";
import panelTitle from "@/components/panelTitle";
import responseInfo from "../../Service/ViolationNoticeReview/rightDetail/responseInfo";
import uploadPic from "@/views/CreditScore/common/uploadPic";
import { fetchPost } from "@/libs/reqCommon";
export default {
  name: "brandStore",
  data() {
    return {
      downTitle: '',
      actionUrl: '',
      logintype: '',
      bulLoading: false,
      BulkImportShow: false,
      reviewstateChange: '合格',
      newShow: false,
      checkboxGroup: [],
      illegalShow: false,
      shopData: [],
      checkprice: '',
      availablecheckprice: '',
      valueType: '',
      synchrotime: '',
      insertLoading: false,
      speechcraft: '',
      radioType: '1',
      downDataShow: false,
      datilData: {},
      detilShow: false,
      customShow: false,
      disbutton: true, //初始化禁掉
      reviewresult: "", // 复查状态
      productid: "", // 产品信息
      activeKey: "",
      newPlateList: [{
        dictCode: "TBTM",
        dictName: "淘宝天猫",
        disabledshow: false,
      },{
        dictCode: "JD",
        dictName: "京东商城",
        disabledshow: false,
      },{
        dictCode: "SN",
        dictName: "苏宁易购",
        disabledshow: false,
      },{
        dictCode: "PDD",
        dictName: "拼多多",
        disabledshow: false,
      },{
        dictCode: "1688",
        dictName: "1688",
        disabledshow: false,
      },{
        dictCode: "DD",
        dictName: "当当网",
        disabledshow: false,
      },{
        dictCode: "WPH",
        dictName: "唯品会",
        disabledshow: false,
      },{
        dictCode: "YFW",
        dictName: "药房网",
        disabledshow: false,
      },{
        dictCode: "YYC",
        dictName: "1药城",
        disabledshow: false,
      }
      // ,{
      //   dictCode: "LZDVN",
      //   dictName: "lazada-越南",
      //   disabledshow: false,
      // },{
      //   dictCode: "LZDSG",
      //   dictName: "lazada-新加坡",
      //   disabledshow: false,
      // },{
      //   dictCode: "LZDMY",
      //   dictName: "lazada-马来西亚",
      //   disabledshow: false,
      // }
    ],
      tableAdd: [],
      searchformDate: [],
      shoptype: '',
      itemid: '',
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
      options2: [],
      cascaderDisabled: false,
      reviewstateShow: false,
      productidChildren: {
        multiple: true,
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      skuloading: true,
      lowPriceLoading: false,
      pageNo: 1,
      pageSize: 10,
      currentPage2: 1,
      total2: 1,
      skuItemid: "",
      skuData: [],
      skuShow: false,
      tableLoading: false,
      deleteShow: false,
      checkAll: 0,
      openNumber: 0,
      formLabelWidth: "100px",
      tableList: [],
      currentPage: 1,
      total: 0,
      batchUserIds: "",
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: "",
        itemtitle: "",
        shopname: "",
        products: "",
        remark: "",
        reviewresult: "",
      },
      delIds: "",
      showType:true,
      setModalInfo:{},//设置表头弹框属性
      ficationLoading: false,
      delType: '',
      syncdates: '',
      bmcKefuName: localStorage.getItem("bmcKefuName"),
      automaticShow: false,
      recFormShow: false,
      rectificationform: '0',
      recFormLoading: false,
      reviewstateLoading: false,
      linkShow: false,
      linkLoading: false,
      linkType: '0',
      isEdit: false,
      reviewForm: {},
      rules: {
        reviewresult: [
          { required: true, message: "请选择复查结果", trigger: "change" }
        ]
      },
      autoreNum: 0,
      autoreTime: 0,
      autoreIds: '',
      automaticLoading: false,
      uodateLoading: false,
      illegalLoading: false,
      autoreviewShow: false,
      autoreviewNum: 0,
      pushMessageShow: false,
      bmcKefuid: '',
    };
  },
  components: {
    pagination,setTableTitle,Shopname,panelTitle,ShopType,responseInfo,uploadPic,couponsZzj
  },
  filters: {
    stringArray: function(value) {
      if (value) {
        let newValue;
        newValue = value.substr(0, value.length - 1);
        return newValue.substr(1, value.length - 1).split(",");
      }
    },
    objToAr: aes.objToArr
  },
  created(){
    this.bmcKefuid = localStorage.getItem('bmcKefuid');
    this.logintype = JSON.parse(localStorage.getItem('userData')).logintype
    this.getRecentDate();
  },
  methods: {
    wechatData() {
      if (this.searchformDate.length == 0) {
        this.$message.warning("请先选择更新时间");
        return;
      }
      let params = {}
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          params.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10);
          params.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10);
        }
      }
      console.log(params)
      fetch({
        url: "/hcm/iprViolationRetrieveData/wechatData",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.$message({
            message: '推送成功',
            type: 'success'
          });
          this.pushMessageShow = false
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 生成截图
    insertScreenshot() {
      let params = this.dataRequest(4)
      if (this.delIds) {
        params.ids = this.delIds
      } else {
        params.ids = 'checkAll'
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/insertScreenshot",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.$message({
            message: '生成成功',
            type: 'success'
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 确定导入
    BulkImport() {
      this.bulLoading = true
      this.$refs.newupload.submit();
    },
    // 取消导入
    BulkImportShowf() {
      this.BulkImportShow = false
      this.$refs.newupload.clearFiles();
    },
    beforeUpload(file) {
      let Xls = file.name
      if(Xls.search("xls") != -1 || Xls.search("xlsx") != -1){
        return file
      }else {
        this.$message.error('上传文件只能是 xls/xlsx 格式!')
        this.bulLoading = false
        return false
      }
    },
    confirmUpload(response) {
      console.log(response.message)
      this.bulLoading = false
      if (response.status && response.status != '10000') {
        this.$message({
          message: response.message,
          type: "error"
        });
        this.$refs.newupload.clearFiles();
      } else {
        this.$message({
          message: '成功',
          type: 'success'
        });
        this.BulkImportShow = false
      }
    },
    autoreviewState() {
      let params={
        platformcode: this.list.platform,
      }
      fetch({
        url: "/hcm/iprViolationRetrieveData/autoreviewState",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          if (res.data == 0) {
            this.autoreviewShow = false
          } else {
            this.autoreviewNum = res.data
            this.autoreviewShow = true
            this.newShow = true
          }
          this.autoreviewStateing()
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    autoreviewStateing() {
      let params={
        platformcode: this.list.platform,
      }
      fetch({
        url: "/hcm/iprViolationRetrieveData/autoreviewStateing",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          
          if (res.data) {
            let arr = []
            arr = res.data.split(',')
            for (let b in arr) {
              for (let a in this.newPlateList) {
                if (this.newPlateList[a].dictCode == arr[b]) {
                  this.newPlateList[a].disabledshow = true
                }
              }
            }
          }

        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 确认删除
    insertReportBatchByIprLowPrice() {
      this.illegalLoading = true
      let params = this.dataRequest()
      params.ids = this.delIds
      if (this.delIds != 'checkAll') {
        params.syncdates = this.syncdates
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/insertReportBatchByIprLowPrice",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text",
        timeout: 60 * 1000 * 60,
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.illegalLoading = false
          this.illegalShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.openNumber = 0
          this.total = 0
          this.getBybmcidAndModule();
        } else {
          this.illegalLoading = false
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.illegalLoading = false
        this.$message.error('接口异常');
      })
    },
    finShopByNameal() {
      let params={
        shopname: '',
        platform: this.list.platform,
      }
      fetch({
        url: "/hcm/hcmShop/finShopByNameal",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.shopData = []
          this.shopData = res.data
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    uodatepystatus() {
      this.uodateLoading = true
      let params = this.dataRequest(3)
      params.reviewresult = this.reviewresult
      this.hcmBrmlogSave('reviewclick')
      fetch({
        url: "hcm/iprViolationRetrieveData/uodatepystatus",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text",
        timeout: 60 * 1000 * 5
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.autoreviewNum = 0
          if (res.data == 0) {
            this.$message.error(res.message);
          } else {
            this.autoreviewNum = res.data
            this.newShow = true
            this.autopython()
          }

        } else {
          this.uodateLoading = false
          this.$message.error(res.message);
        }
      })
    },
    autopython() {
      this.uodateLoading = true
      let params = this.dataRequest(3)
      params.reviewresult = this.reviewresult
      //自动复查
      fetch({
        url: "hcm/iprViolationRetrieveData/autopython",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          this.uodateLoading = false
          this.automaticShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.getBybmcidAndModule();
        }
      });
    },
    autoreview() {
      if (!this.reviewresult) {
        this.$message({
          message: '请选择复查状态',
          type: 'warning'
        });
        return
      }
      if (this.checkboxGroup.length == 0) {
        this.$message({
          message: '请选择平台',
          type: 'warning'
        });
        return
      }
      this.automaticLoading = true
      let params = this.dataRequest(3)
      params.reviewresult = this.reviewresult
      //自动复查
      fetch({
        url: "hcm/iprViolationRetrieveData/autoreview",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text",
        timeout: 60 * 1000 * 5,
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          this.autoreIds = ''
          this.autoreNum = 0
          this.autoreTime = 0
          if (result.data.ids) {
            this.autoreIds = result.data.ids
            this.autoreNum = result.data.ids.split(',').length
            this.autoreTime = result.data.time
          }
          this.automaticLoading = false
        }
      });
    },
    reviewConfirm() {
      console.log(this.reviewForm)
      this.$refs.reviewForm.validate(valid => {
        if (valid) {
          let query = {
            ...this.reviewForm,
            id: this.datilData.id,
          };
          fetchPost("/hcm/iprViolationRetrieveData/updatereview", query).then(res => {
            if (res.status === "10000") {
              this.$message({
                message: "复查成功",
                type: "success"
              });
              this.isEdit = false;
              let row = {}
              row.id = this.datilData.id
              this.onOpenDrawer(row)
            }
          });
        } else {
          return false;
        }
      });
    },
    editClick(rectificationform,reviewresult) {
      if (!rectificationform && rectificationform !=0 || !reviewresult) {
        this.$message({
          message: '选择的链接未设置整改形式，设置后点击。',
          type: 'warning'
        });
        return
      }
      this.isEdit = true;
      this.reviewForm = {
        reviewstate: this.datilData.reviewstate
      };
      if (this.datilData.reviewresult == "合格" || this.datilData.reviewresult == "不合格") {
        this.reviewForm = {
          reviewresult: this.datilData.reviewresult,
        };
      }
    },
    getpic(imgList) {
      this.reviewForm.reviewurl = imgList;
    },
    saveCheckPrice() {
      let url
      let params = this.dataRequest()
      params.ids = this.delIds
      if (this.delIds != 'checkAll') {
        params.syncdates = this.syncdates
      }
      if (this.linkType == '1') {
        url = 'hcm/iprViolationRetrieveData/saveIsspecial'
        this.checkprice = ''
        this.availablecheckprice = ''
      } else {
        url = 'hcm/iprViolationRetrieveData/saveCheckPrice'
        params.checkprice = this.checkprice
        params.availablecheckprice = this.availablecheckprice
      }
      this.linkLoading = true
      fetch({
        url: url,
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.linkLoading = false
          this.linkShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.getBybmcidAndModule();
        } else {
          this.linkLoading = false
          this.$message.error(res.message);
        }
      })
    },
    linkClick() {
      this.linkShow = true
    },
    // 整改形式
    recForm() {
      this.recFormLoading = true
      let params = this.dataRequest()
      params.ids = this.delIds
      if (this.delIds != 'checkAll') {
        params.syncdates = this.syncdates
      }
      params.rectificationform = this.rectificationform
      fetch({
        url: "hcm/iprViolationRetrieveData/updateRectificationform ",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.recFormLoading = false
          this.recFormShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.getBybmcidAndModule();
        } else {
          this.recFormLoading = false
          this.$message.error(res.message);
        }
      })
    },
    updatereviewAll() {
      this.reviewstateLoading = true
      let params = this.dataRequest()
      params.ids = this.delIds
      if (this.delIds != 'checkAll') {
        params.syncdates = this.syncdates
      }
      params.updatereviewresult = this.reviewstateChange
      fetch({
        url: "hcm/iprViolationRetrieveData/updatereviewAll ",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.reviewstateLoading = false
          this.reviewstateShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.getBybmcidAndModule();
        } else {
          this.reviewstateLoading = false
          this.$message.error(res.message);
        }
      })
    },
    insertSpeechcraft() {
      this.insertLoading = true
      let params = {
        speechcraft: this.speechcraft
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/insertSpeechcraft",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          this.insertLoading = false
          this.customShow = false
          this.speechcraft = ''
        }
      });
    },
    // 打开详情页
    onOpenDrawer(row) {
      if (row.itemtype == 2) {
        return
      }
      let params = {
        id: row.id
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/iprViolationRetrieveDatadetails",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          this.detilShow = true
          this.datilData = result.data
        }
      });
    },
    customSpeech() {
      fetch({
        url: "hcm/iprViolationRetrieveData/getSpeechcraft",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          this.speechcraft = result.data
          this.customShow = true
        }
      });

    },
    // 确认删除
    deleteReview() {
      this.ficationLoading = true
      let params = this.dataRequest()
      params.ids = this.delIds
      if (this.delIds != 'checkAll') {
        params.syncdates = this.syncdates
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/deleteReview",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.ficationLoading = false
          this.deleteShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.openNumber = 0
          this.total = 0
          this.getBybmcidAndModule();
        } else {
          this.ficationLoading = false
          this.$message.error(res.message);
        }
      })
    },
    // 取消删除
    delCancel() {
      this.deleteShow = false
      this.delType = ''
      this.checkAll = ''
      this.delIds = ''
    },
    // 删除/整改形式
    onOpenDeleteDia(e) {
      console.log(this.selectRows)
      this.delIds = ''
      if (this.checkAll == 2) {
        this.delType = '全部'
        this.delIds = "checkAll"
      } else {
        this.delType = this.openNumber + '条'
        let arrIds = []
        let syncdates = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].ids)
          syncdates.push(this.selectRows[i].syncdate)
        }
        this.delIds = arrIds.join(',')
        this.syncdates = Array.from(new Set(syncdates)).join(',')
      }
      if (e != 4 && e != 7 && e != 8 && e != 10 && e != 11) {
        if (this.delIds == '' || this.openNumber == 0) {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
      }
      console.log(this.delIds)
      if (e == 1) {
        this.recFormShow = true
      } else if (e == 2) {
        this.deleteShow = true
      } else if (e == 3) {
        this.checkprice = ''
        this.availablecheckprice = ''
        this.linkShow = true
      } else if (e == 4) {
        this.automaticShow = true
      } else if (e == 5) {
        this.illegalShow = true
      } else if (e == 6) {
        this.reviewstateShow = true
      } else if (e == 7) {
        this.downDataShow = true
      } else if (e == 8) {
        this.downTitle = "批量导入"
        this.actionUrl = "hcm/iprViolationRetrieveData/readExcelFile"
        this.bulLoading = false
        this.BulkImportShow = true
        this.$refs.newupload.clearFiles();
      } else if (e == 9) {
        this.insertScreenshot()
      } else if (e == 10) {
        this.pushMessageShow = true
      } else {
        this.downTitle = "检索数据导入"
        this.actionUrl = "hcm/iprViolationRetrieveData/readExcelFileProduct"
        this.bulLoading = false
        this.BulkImportShow = true
        this.$refs.newupload.clearFiles();
      } 
    },
    // 序号勾选
    handleSelectionChange(val) {
      if (this.checkAll != 2) {
        this.openNumber = val.length;
        this.selectRows = val;
      }
    },
    // 勾选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleAllSelection(row);
          this.openNumber = this.total
          this.checkAll = 2
        });
      } else {
        this.$refs.multipleTable.clearSelection();
        this.checkAll = 1
        this.openNumber = 0
      }
    },
    // 选择平台并默认初始化
    navChange(item) {
      this.LowPriceLoading = false
      this.pageNo = 1;
      this.pageSize = 10;
      this.list.pageNo = 1;
      this.list.pageSize = 10;
      this.currentPage = 0;
      this.list.platform = "";
      this.searchformDate = [];
      this.shoptype = [];
      this.itemid = "";
      this.list.itemtitle = "";
      this.list.shopname = "";
      this.list.remark = "";
      this.list.reviewresult = "";
      this.list.products = "";
      this.newShow = false;
      if (item.dictCode == "TBTM") {
        this.activeKey = "TBTM";
        this.list.platform = item.dictCode;
      } else {
        this.activeKey = item.dictCode;
        this.list.platform = item.dictCode;
      }
      this.autoreviewState()
      this.finShopByNameal()
      this.getRecentDate()
      this.getBybmcidAndModule();
    },
    // 设置表头
    setTableTitle(){
      if (this.tableAdd.length == 0) {
        this.$message({
          message: '请先选择平台',
          type: 'warning'
        });
        return
      }
      this.setModalInfo = {isShow:true}
      this.$refs.setModal.retrieveLowPrice(this.tableAdd)
    },
    reqTableData(){
      this.getBybmcidAndModule();
    },
    getRecentDate(picker,n){
      if (!n) {
        n = 1
      }
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.searchformDate[0] = end;
        this.searchformDate[1] = end;
      } else {
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
      }
    },
    handleChange(value) {
      this.productid = value
    },
    getListBybmcid2(data) {
      if (data == true && this.options2.length == 0) {
        this.divLoading = true
        this.cascaderDisabled = true
        this.divShow = true
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.options2 = result.data;
            this.cascaderDisabled = false
            this.divShow = false
          }
        });
      }
    },
    // 统一数据传参
    dataRequest(e) {
      console.log(e)
      let newProductid = []
      let datas = {};
      if (e != 4) {
        datas.pageNo = this.list.pageNo
        datas.pageSize = this.list.pageSize
      }
      if (e == 1) {
        datas.platform = this.list.platform
      } else if (e == 3) {
        let platArr = []
        for (let a in this.newPlateList) {
          for (let b in this.checkboxGroup) {
            if (this.checkboxGroup[b] == this.newPlateList[a].dictName) {
              platArr.push(this.newPlateList[a].dictCode)
            }
          }
        }
        datas.platformcode = platArr.join(",")
      } else {
        datas.platformcode = this.list.platform
      }
      if (e != 2) {
        if (this.list.reviewresult) {
          datas.reviewresult = this.list.reviewresult;
        }
      }
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          datas.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10);
        }
      }
      if (this.shoptype) {
        datas.shoptype = this.shoptype;
      }
      if (this.itemid) {
        datas.itemid = this.itemid;
      }
      if (this.list.itemtitle) {
        datas.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname.length != 0) {
        datas.shopname = this.list.shopname.join(",");
      }
      if (this.list.remark) {
        datas.remark = this.list.remark;
      }
      if (this.list.products) {
        datas.products = this.list.products;
      }

      if (this.productid && this.productid.length > 0) {
        for (var a = 0; a < this.productid.length; a++) {
          if (this.productid[a][1]) {
            newProductid.push(this.productid[a][1].split(",")[0])
          }
        }
        if (newProductid.length > 0) {
          datas.products = newProductid.join(",")
        }
      }
      return datas
    },
    hcmBrmlogSave(data) {
      let that = this;
      let datas = {
        modlename : data
      };
      fetch({
        url: "hcm/hcmBrmlog/save",
        method: "post",
        data: datas,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {

        }
      });
    },
    // 下载
    downTable() {
      this.lowPriceLoading = true
      let newProductid = []
      let datas = this.dataRequest(1)
      let nameXlsx
      if (this.radioType == '1') {
        nameXlsx = this.bmcKefuName + this.activeKey + '全部数据.xlsx'
        this.hcmBrmlogSave('retrievedataexcel')
      } else if (this.radioType == '2') {
        nameXlsx = this.bmcKefuName + this.activeKey + '通知数据.xlsx'
        this.hcmBrmlogSave('noticeexcel')
      } else if (this.radioType == '3') {
        nameXlsx = this.bmcKefuName + this.activeKey + '复查数据.xlsx'
      } else if (this.radioType == '4') {
        nameXlsx = this.bmcKefuName + this.activeKey + '导入数据.xlsx'
      }
      if (this.delIds) {
        datas.ids = this.delIds
      } else {
        datas.ids = 'checkAll'
      }

      datas.type = this.radioType
      fetch({
        url: "hcm/iprViolationRetrieveData/downloadIprLowPriceListByAll",
        method: "post",
        data: datas,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 5
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", nameXlsx);
        document.body.appendChild(link);
        link.click();
        this.lowPriceLoading = false
      });
    },
    // 查询
    getIprViolationRetrieveDataList(e) {
      this.openNumber = 0
      this.tableLoading = true
      if (e == 1) {
        this.list.pageNo = 1;
      }
      let datas = this.dataRequest()
      fetch({
        url: "hcm/iprViolationRetrieveData/getIprViolationRetrieveDataList",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {

          this.tableLoading = false
          this.disbutton = false
          this.tableList = data.content;
          this.total = data.totalElements;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    violationRetrieveModelList(data) {
      let titleData = data
      fetch({
        url: "hcm/iprViolationRetrieveModel/violationRetrieveModelList",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.tableAdd = []
          for (let a in titleData) {
            if (titleData[a].fieldvalue == 'logopicurl'
              || titleData[a].fieldvalue == 'itemtitle'
              || titleData[a].fieldvalue == 'itemlink'
              || titleData[a].fieldvalue == 'productname'
              || titleData[a].fieldvalue == 'price'
              || titleData[a].fieldvalue == 'islowprice'
              || titleData[a].fieldvalue == 'checkprice'
              || titleData[a].fieldvalue == 'availableprice'
              || titleData[a].fieldvalue == 'availableislowprice'
              || titleData[a].fieldvalue == 'availablecheckprice'
              || titleData[a].fieldvalue == 'coupons'
              || titleData[a].fieldvalue == 'shopname'
              || titleData[a].fieldvalue == 'wangwang'
              || titleData[a].fieldvalue == 'platform'
              || titleData[a].fieldvalue == 'authorize'
              || titleData[a].fieldvalue == 'shoptype'
              || titleData[a].fieldvalue == 'productprice'
              || titleData[a].fieldvalue == 'platformcode'
              || titleData[a].fieldvalue == 'skuname'
              || titleData[a].fieldvalue == 'camisreport'
              || titleData[a].fieldvalue == 'productid'
              || titleData[a].fieldvalue == 'reviewresult'
              || titleData[a].fieldvalue == 'status'
              || titleData[a].fieldvalue == 'synchrotime'
            ) {
              titleData[a].showtype = 2
            }
            for (let b in res.data) {
              if (titleData[a].fieldvalue == res.data[b].fieldvalue) {
                titleData[a].showtype = 2
              }
            }
          }
          this.tableAdd = titleData
          this.getIprViolationRetrieveDataList();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    getBybmcidAndModule() {
      fetch({
        url: "hcm/iprViolationRetrieveData/violationRetrieveModel",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.violationRetrieveModelList(data)
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // SKU列表
    skuListChildShow(e,itemid,synchrotime,platformcode) {
      if (e == 1) {
        this.currentPage2 = 1;
        this.pageNo = 1;
        this.pageSize = 10;
      }
      if (synchrotime) {
        this.synchrotime = synchrotime
      }
      this.skuloading = true
      if (itemid) {
        this.skuItemid = itemid;
      }
      this.skuShow = true;
      let datas = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        itemid: this.skuItemid,
        syncdate: this.synchrotime,
        platformcode: this.list.platform
      };
      fetch({
        url: "hcm/iprViolationRetrieveData/getIprViolationRetrieveDataSkuList  ",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.skuloading = false
          this.skuData = data.content;
          this.total2 = data.totalElements;
        } else {
          this.skuloading = false
          this.$message.error(res.message);
        }
      });
    },
    //每页
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getIprViolationRetrieveDataList();
    },
    //当前页
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getIprViolationRetrieveDataList();
    },
    handleSizeChange2(val) {
      this.pageSize = val;
      this.skuListChildShow(2);
    },
    handleCurrentChange2(val) {
      this.pageNo = val;
      this.skuListChildShow(2);
    }
  }
};
</script>

<style lang="scss">
  @import "style/lowPriceDetails.scss";
  #setTags{
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .el-checkbox-button:first-child .el-checkbox-button__inner {
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      -webkit-box-shadow: none!important;
      margin: 5px;
      box-shadow: none!important;
    }
    .el-checkbox-button--mini .el-checkbox-button__inner {
      padding: 7px 15px;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      margin: 5px;
    }
    .el-checkbox-button.is-checked .el-checkbox-button__inner {
      color: #bda571;
      background-color: #f8f6f1;
      border-color: #bda571;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    .el-checkbox-button__inner:hover {
      color: #bda571;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #bda571;
      background: #bda571;
    }
    .el-radio__input.is-checked+.el-radio__label {
      color: #666;
    }
    .el-radio__inner:hover {
      border-color: #bda571;
    }
    #setTagsAdd {
      .el-button {
        border: 1px dashed #DCDFE6 !important;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
  }
</style>
<style scoped lang="scss">
  .discounter {
    text-align: center;
    font-size: 12px;
    color: white;
    margin-bottom: 7px;
    line-height: 20px;
    float: left;
    clear: both;
  }
  .title {
    text-align: center;
    span {
      padding-left: 33px;
      cursor: pointer;
    }
    .span:hover,
    .active {
      color: #108cee;
    }
  }
  .violationInfo{
  	.panel-header .text{
  		height: 25px;
  		border:none;
  	}
  }
  .pre_img{
  	position: relative;
    display: inline-block;
    margin: 0px 5px 0 20px;
  	color: #409eff;
  	cursor: pointer;
  	.none_img{
  		width: 30px;
  		height: 26px;
  		position: absolute;
  		top: 0;
  		opacity: 0;
  		left: 0;
  	}
  }

  .pre_img{
  	margin: 0px 5px 0 20px;
  }

  .con-info {
  	.item {
  		margin: 10px 0;
  		&-flex{
  			display: flex;
  			justify-content: space-between;
  			width: 400px;
  		}
  		.title{
  			vertical-align: middle;
  			display: inline-block;
  			width: 100px;
  			text-align: right;
  			line-height: 28px;
  		}
  		p{
  			margin: 0;
  		}
  		.con{
  			display: inline-block;
  			padding: 0 0 0 20px;
  			width: calc(100% - 120px);
  			vertical-align: text-top;
  		}
  		.img-wrap {
  			vertical-align: text-top;
  			img{
  				width:90px;
  				height:90px;
  				margin: 0 10px 10px 0;
  			}
  		}
  	}
  }
  .el-checkbox-button:first-child .el-checkbox-button__inner {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    -webkit-box-shadow: none!important;
    margin: 5px;
    box-shadow: none!important;
  }
  .el-checkbox-button--mini .el-checkbox-button__inner {
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    margin: 5px;
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: #bda571;
    background-color: #f8f6f1;
    border-color: #bda571;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-checkbox-button__inner:hover {
    color: #bda571;
  }
</style>
